import { AtIcon } from '@curran-catalog/curran-atomic-library'

export const ErrorView = () => (
  <div className="flex flex-col pb-12 tw-justify-center h-[350px]">
    <div className="mb-6 mx-auto">
      <AtIcon type="cart-error" size={128} />
    </div>
    <div className="mx-auto transition delay-200 duration-300 ease-in">
      <p className="sm:text-center my-4 text-lg sm:text-xl">
        There was an issue loading your cart. Please try again later.
      </p>
    </div>
  </div>
)
